import { useFeature } from '@monofront/business/contexts';

const FEATURE_CART_MAX_WEIGHT = 'cart_max_weight';

export const useCartMaxWeight = (): number => {
  const feature = useFeature<number>(FEATURE_CART_MAX_WEIGHT);

  return feature.value ?? 45;
};
